module.exports = __webpack_public_path__ + "img/ding.592bef19.svg";